import type { CalendarSourceBoard, Card, Label } from '@/entities/board';

/** Where a task of the planner comes from (workspace fields are absent for board-only guests). */
export type MyTaskBoard = CalendarSourceBoard;

export interface MyTaskPerson {
  user_id: string;
  display_name: string;
}

/** `GET /me/tasks/summary`: counts are over ACTIVE tasks only. */
export interface MyTasksSummary {
  overdue: number;
  /** Due today and not overdue yet (`overdue + today` never counts a task twice). */
  today: number;
  total: number;
  preview: Card[];
  boards: MyTaskBoard[];
}

/** `GET /me/tasks`. */
export interface MyTasksData {
  cards: Card[];
  labels: Label[];
  boards: MyTaskBoard[];
  people: MyTaskPerson[];
  /** More tasks matched than were returned: narrow the filters. */
  truncated: boolean;
}

export type TaskBucket = 'overdue' | 'today' | 'upcoming' | 'none';
export type TaskStatus = 'open' | 'completed' | 'all';

export const TASK_BUCKETS: readonly TaskBucket[] = ['overdue', 'today', 'upcoming', 'none'];

export interface MyTasksFilter {
  q: string;
  boardIds: string[];
  workspaceIds: string[];
  status: TaskStatus;
  buckets: TaskBucket[];
  labelIds: string[];
}

export const EMPTY_TASKS_FILTER: MyTasksFilter = {
  q: '',
  boardIds: [],
  workspaceIds: [],
  status: 'open',
  buckets: [],
  labelIds: [],
};
